export const ORG_ROLES = ['owner', 'admin', 'manager', 'user'] as const;
export type OrgRole = (typeof ORG_ROLES)[number];

export const ASSIGNABLE_ORG_ROLES = ['admin', 'manager', 'user'] as const;
export type AssignableOrgRole = (typeof ASSIGNABLE_ORG_ROLES)[number];

export function isOrgRole(value: string | null | undefined): value is OrgRole {
  return value != null && (ORG_ROLES as readonly string[]).includes(value);
}

export function isOrgAdmin(role: string | null | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

export function isOrgManager(role: string | null | undefined): boolean {
  return isOrgAdmin(role) || role === 'manager';
}
